export default __webpack_public_path__ + "static/media/Maryn_Ryan_Soref.d6808daf.jpg";